import { listCategory } from '@/api/CategoryApi'
const category = {
  state: {
    categorys: []
  },
  getters: {
    categoryList(state) {
      return state.categorys
    }
  },
  mutations: {
    SET_CATEGORY(state, categorys) {
      state.categorys = categorys
    }
  },
  actions: {
    FetchCategory(context) {
      listCategory().then((resp) => {
        if (resp.code === 0) {
          context.commit('SET_CATEGORY', resp.data)
        }
      })
    }
  }
}

export default category
